import { FC, useEffect } from "react";
import { usePostUsersMeOrganisationsCurrentAccountsByAccountIdAndResourceTypeMetricsMutation as useMetricsMutation } from "../../../../../../../services/cloudchipr.api";
import { ResourceDetailsMetricsContent } from "../common/metrics/ResourceDetailsMetricsContent";
import { metricAvailableResourceTypes } from "../../../utils/constants/metrics";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsTargetSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetSelector";
import { resourceDetailsTargetResourceIsKubernetesSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceIsKubernetesSelector";
import { ResourceDetailsK8SMetricsTabContent } from "@/components/pages/common/resource-details/components/content/metrics-content/ResourceDetailsK8SMetricsTabContent";

export const ResourceDetailsMetricsTabContent: FC = () => {
  const resource = useAppSelector(resourceDetailsTargetSelector);
  const isKubernetes = useAppSelector(
    resourceDetailsTargetResourceIsKubernetesSelector,
  );

  const accountId = resource?.resource?.accountId ?? "";
  const resourceType = resource?.resource?.resourceType ?? "ec2";
  const providerUniqueIdentifier =
    resource?.resource?.provider_unique_identifier ?? "";

  const [trigger, { data, isLoading }] = useMetricsMutation();

  useEffect(() => {
    if (
      isKubernetes ||
      !accountId ||
      !resourceType ||
      !providerUniqueIdentifier
    ) {
      return;
    }

    if (!metricAvailableResourceTypes.has(resourceType)) {
      return;
    }

    trigger({
      accountId,
      resourceType,
      body: { provider_unique_identifier: providerUniqueIdentifier },
    });
  }, [
    trigger,
    isKubernetes,
    accountId,
    resourceType,
    providerUniqueIdentifier,
  ]);

  if (isKubernetes) {
    return <ResourceDetailsK8SMetricsTabContent />;
  }

  return (
    <ResourceDetailsMetricsContent
      data={data}
      loading={isLoading}
      resourceType={resourceType}
    />
  );
};
